import { render, staticRenderFns } from "./comp-todoList.vue?vue&type=template&id=ca6b3bec"
import script from "./comp-todoList.vue?vue&type=script&lang=js"
export * from "./comp-todoList.vue?vue&type=script&lang=js"
import style0 from "./comp-todoList.vue?vue&type=style&index=0&id=ca6b3bec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports